export default "__VITE_ASSET__DHftvNUg__"